import { ShortcutHelper } from '@/services/helpers/ShortcutHelper'

export default defineNuxtPlugin(() => {
  const userStore = useUserStore()
  const token = localStorage.getItem('auth-token')
  if (token) {
    userStore.editable.token = token
  }
  const currentTenant = localStorage.getItem('current-tenant-id')
  if (currentTenant) {
    userStore.editable.currentTenantId = currentTenant
  }
  // Instantiated here (outside any component) so its useLocalStorage listeners
  // don't get tied to, and torn down with, whichever component happens to mount first.
  usePreferencesStore()
  const { isMobileDevice, isAppOrWebWithMobile, addDeepLinking, inviteToDownloadIfMobileBrowser } = useDeviceStore()
  isMobileDevice()
  isAppOrWebWithMobile()
  addDeepLinking()
  ShortcutHelper.init()
  inviteToDownloadIfMobileBrowser()
})
